import React, { useState } from "react";
import { Row, Card } from 'antd'; 
import { compose, graphql, ApolloConsumer } from 'react-apollo';
import { addRoomM, updateRoomM } from '../../../graphql/mutation/room';
import { getRoom } from '../../../graphql/query/rooms';
import AntSpin from "../../common/AntSpin";
import SimpleInput from "../../common/SimpleInput";
import SelectBranch from "../../common/selects/Branch";
import { handleInput } from "./handleInput";
import { validForm } from "../../../functions/validForm";
import { openNotificationWithIcon } from "../../common/Notification";
import SideButton from "../../common/SideButton";

function RoomForm({props, addRoom, updateRoom}){
    let [ room, setRoom ] = useState({
        _id: "",
        name: undefined,
        link: undefined,
        branch: undefined
    });
    let [ loading, setLoading ] = useState(false);
    
    function update(){
        let body = {
            room,
            updateRoom
        };

        props.UPDATE_ROOM(body);
        openNotificationWithIcon('success', "Sucesso", "Sala atualizada com sucesso", "", 7);
        
        setRoom(room = {...room,
            _id: "",
            name: undefined,
            link: undefined,
            branch: undefined
        })
    }

    function add(){
        let body = {
            room,
            addRoom
        };
       
        props.ADD_ROOM(body);
        openNotificationWithIcon('success', "Sucesso", "Sala adicionada com sucesso", "", 7);

        setRoom(room = {...room,
            _id: "",
            name: undefined,
            link: undefined,
            branch: undefined
        })
    }

    async function getRoomDB(connection){
        if(localStorage.getItem('@Ossel:UpdateID')){
            setLoading(loading = true);

            const { data } = await connection.query({
                query: getRoom,
                variables: { _id: localStorage.getItem('@Ossel:UpdateID') }
            }); 
          
            setRoom(room = {...room,
                _id: data.room._id,
                name: data.room.name,
                link: data.room.link,
                branch: data.room.branch_info[0]._id
            });
          
            localStorage.removeItem('@Ossel:UpdateID');
            setLoading(loading = false);
        }

        return null
    }

    function handleOk(){
        if(!validForm(room)){
            openNotificationWithIcon('warning', "Aviso", "Há informações incompletas no formulario.", "", 5);
            return 
        }
        
        if(room._id === "") add()
        else update()   
    }

    function renderBody(connection){
        getRoomDB(connection);

        if(!loading) return(
            <Row>
                <Card
                    title="Cadastro"
                    style={{ width: "95%", marginTop: 25, marginLeft: "auto", marginRight: "auto" }}
                >

                    <SimpleInput
                        data={room} 
                        setData={setRoom} 
                        handleInput={handleInput} 
                        label={"Nome da Sala"}
                        inputName={"name"}
                        placeholder={"Ex: Tulipa"}
                        required={true}
                    />

                    <SimpleInput
                        data={room} 
                        setData={setRoom} 
                        handleInput={handleInput} 
                        label={"Link Câmera"}
                        inputName={"link"}
                        placeholder={"Ex: rtsp://admin:1234@177.135.160.218:554/cam/realmonitor?channel=10&subtype=0"}
                        required={true}
                    />

                    <SelectBranch
                        data1={room} 
                        setData={setRoom} 
                        handleInput={handleInput} 
                        profile={props.user}
                    />

                    <SideButton
                        clickAction={handleOk}
                    />
                </Card>
            </Row>
        )
        else return <AntSpin marginTop={"20%"}/>
    }

    return (
        <ApolloConsumer>
            {client => renderBody(client)}
        </ApolloConsumer>
    );
}

export default compose(
    graphql( addRoomM, { name: "addRoom" } ),
    graphql( updateRoomM, { name: "updateRoom" } ),
)(RoomForm); 


// WEBPACK FOOTER //
// ./src/components/general/roomFormWrapper/RoomForm.jsx